<template>
<div class="yin-yang-chart-group-wrapper" :style="{
  '--related-chart-width': relatedChartWidth
}">
  <div
    v-for="data in dataList"
    :key="data.id"
    class="yin-yang-chart-group"
  >
    <x-y-chart
      :data-config="data"
      :unit-prop="unitProp"
      :chart-type="chartType"
      :stack-type="stackType"
      :download-name="downloadName"
      :chart-height="chartHeight"
    />

    <div class="yin-yang-related-chart">
      <yin-yang-related-chart-group :site-data="data" />
    </div>
  </div>
</div>
</template>

<script>
import XYChart from '../DataChart/XYChart'
import RelatedChart from './RelatedChart'
import YinYangRelatedChartGroup, {P_YIN_YANG_CONFIG, G_YIN_YANG_CONFIG} from './YinYangRelatedChartGroup'

export const PM_YIN_YANG_CONFIG = P_YIN_YANG_CONFIG
export const PM_YIN_YANG_FACTOR_IDS = Object.freeze(Object.keys(PM_YIN_YANG_CONFIG))
export const PM_YIN_YANG_FACTOR_IDS_REGEXP = new RegExp(`^${PM_YIN_YANG_FACTOR_IDS.join('|')}$`)

export const GAS_YIN_YANG_CONFIG = G_YIN_YANG_CONFIG
export const GAS_YIN_YANG_FACTOR_IDS = Object.freeze(Object.keys(GAS_YIN_YANG_CONFIG))
export const GAS_YIN_YANG_FACTOR_IDS_REGEXP = new RegExp(`^${GAS_YIN_YANG_FACTOR_IDS.join('|')}$`)

export const ALL_YIN_YANG_FACTOR_IDS_REGEXP = new RegExp(`^${[...PM_YIN_YANG_FACTOR_IDS, ...GAS_YIN_YANG_FACTOR_IDS].join('|')}$`)

export default {
  name: 'YinYangChart',
  components: {YinYangRelatedChartGroup, XYChart, RelatedChart},
  props: {
    dataList: {
      required: true,
      type: Array
    },
    unitProp: {
      required: true,
      type: String
    },
    chartHeight: {
      type: String,
      default: 'auto'
    },
    downloadName: {
      required: true,
      type: String
    },
    relatedChartWidth: {
      type: String,
      default: '400px'
    }
  },
  data: () => ({
    chartType: 'bar',
    stackType: 1
  })
}
</script>

<style lang="scss">
.yin-yang-chart-group-wrapper {
  --related-chart-header-height: 30px;

  display: flex;
  flex-direction: column;
  gap: 22px;
  width: 100%;
  height: 100%;

  > .yin-yang-chart-group {
    display: grid;
    grid-template-columns: auto var(--related-chart-width);
    min-height: calc((var(--related-chart-header-height) + var(--related-chart-width)) * 2);
    height: 100%;

    > * {
      min: {
        width: 0;
        height: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/YinYangChart.vue